<template>
  <a-table
    :dataSource="dataSource"
    :columns="columns"
    :scroll="{ x: 1530 }"
    :pagination="false"
    @resizeColumn="handleResizeColumn"
    class="mb40"
  >
    <template #personGroup="{text}">
      <span>{{ personGroupDic[text - 0] }}</span>
    </template>
    <template #scene="{text}">
      <span>{{ sceneDic[text - 0] }}</span>
    </template>
    <template #popupType="{text}">
      <span>{{ sceneDicDic[text - 0] }}</span>
    </template>
    <template #sceneSwitch="{text}">
      <span
        ><a-switch
          :checked="text"
          :checkedValue="1"
          :unCheckedValue="0"
          checked-children="开"
          un-checked-children="关"
      /></span>
    </template>
    <template #countLimit="{text}">
      <span>{{ text }}</span>
    </template>
    <template #popupInterval="{text}">
      <span>{{ text }}</span>
    </template>
    <template #durationOnPage="{text}">
      <span>{{ text }}</span>
    </template>
    <template #popupImageUrl="{text}">
      <span><img :src="text" style="width: 100px;"/></span>
    </template>
    <template #popupCopywriting="{text}">
      <span>{{ text }}</span>
    </template>
    <template #btnCopywriting="{text}">
      <span>{{ text }}</span>
    </template>
    <template #linkUrl="{text}">
      <span>{{ text }}</span>
    </template>
    <template #activityEvent="{text}">
      <span>{{ text }}</span>
    </template>
    <template #style="{text}">
      <span>{{ text }}</span>
    </template>
    <template #copyCopywriting="{text}">
      <span>{{ text }}</span>
    </template>
    <template #countdownSwitch="{text}">
      <span>{{ text }}</span>
    </template>
    <template #countdownSecond="{text}">
      <span>{{ text }}</span>
    </template>
    <template #orderMaxAmount="{record}">
      <span>{{ record.orderMinAmount }} - </span>
      <span>
        {{ record.orderMaxAmount }}
      </span>
    </template>
    <template #deal="{record, text}">
      <div class="tal">
        <a-button
          type="link"
          @click="
            jumpPage('AlertManageDetail', {
              ...text,
              ...searchParams,
              dealType: 'edit'
            })
          "
          >编辑</a-button
        >
        <a-popconfirm
          title="是否确定删除该条记录?"
          ok-text="确定"
          cancel-text="取消"
          trigger="click"
          @confirm="() => deleteFun({ ...record })"
          @cancel="cancel"
        >
          <a-button type="link">删除</a-button>
        </a-popconfirm>
      </div>
    </template>
  </a-table>
</template>
<script>
import { inject, toRefs, ref, reactive } from 'vue'
export default {
  setup() {
    const dics = reactive({
      personGroupDic: {
        1: '浏览未购',
        2: '结算未购',
        3: '加车未结算',
        4: '支付成功'
      },
      sceneDic: { 1: 'PDP', 2: 'Checkout', 3: 'Add to bag', 4: '活动日程' },
      sceneDicDic: { 1: '优惠券发放', 2: '链接跳转', 3: '复制', 4: '日程提醒' },
      sceneSwitch: [
        { value: 0, label: '关' },
        { value: 1, label: '开' }
      ]
    })
    const columns = ref([
      {
        title: 'ID',
        dataIndex: 'id',
        key: 'id',
        resizable: true,
        width: 100,
        align: 'center'
      },
      {
        title: '人群',
        slots: { customRender: 'personGroup' },
        dataIndex: 'personGroup',
        key: 'personGroup',
        width: 150,
        resizable: true,
        align: 'center'
      },
      {
        title: '场景',
        slots: { customRender: 'scene' },
        dataIndex: 'scene',
        key: 'scene',
        resizable: true,
        align: 'center',
        width: 180
      },
      {
        title: '弹窗类型',
        slots: { customRender: 'popupType' },
        dataIndex: 'popupType',
        key: 'popupType',
        resizable: true,
        align: 'center',
        width: 100
      },
      {
        title: '场景开关',
        slots: { customRender: 'sceneSwitch' },
        dataIndex: 'sceneSwitch',
        popupType: 'sceneSwitch',
        resizable: true,
        align: 'center',
        width: 120
      },
      {
        title: '弹出次数限制',
        dataIndex: 'countLimit',
        slots: { customRender: 'countLimit' },
        key: 'countLimit',
        align: 'center',
        width: 120
      },
      {
        title: '弹出间隔',
        dataIndex: 'popupInterval',
        slots: { customRender: 'popupInterval' },
        key: 'popupInterval',
        resizable: true,
        align: 'center',
        width: 120
      },
      {
        title: '页面停留时长',
        dataIndex: 'durationOnPage',
        slots: { customRender: 'durationOnPage' },
        key: 'durationOnPage',
        resizable: true,
        align: 'center',
        width: 120
      },
      {
        title: '弹窗图片',
        dataIndex: 'popupImageUrl',
        slots: { customRender: 'popupImageUrl' },
        key: 'popupImageUrl',
        resizable: true,
        align: 'center',
        width: 180
      },
      {
        title: '弹窗文案',
        dataIndex: 'popupCopywriting',
        slots: { customRender: 'popupCopywriting' },
        popupCopywriting: 'popupCopywriting',
        resizable: true,
        align: 'center',
        width: 180
      },
      {
        title: '订单金额区间',
        dataIndex: 'orderMaxAmount',
        slots: { customRender: 'orderMaxAmount' },
        resizable: true,
        align: 'center',
        width: 180
      },
      {
        title: 'btn文案',
        dataIndex: 'btnCopywriting',
        slots: { customRender: 'btnCopywriting' },
        key: 'btnCopywriting',
        resizable: true,
        align: 'center',
        width: 200
      },
      {
        title: '跳转链接',
        dataIndex: 'linkUrl',
        slots: { customRender: 'linkUrl' },
        type: 'linkUrl',
        resizable: true,
        align: 'center',
        width: 200
      },
      {
        title: '活动事件名称',
        dataIndex: 'activityEvent',
        slots: { customRender: 'activityEvent' },
        key: 'activityEvent',
        resizable: true,
        align: 'center',
        width: 200
      },
      {
        title: '弹窗样式',
        dataIndex: 'style',
        slots: { customRender: 'style' },
        key: 'style',
        resizable: true,
        align: 'center',
        width: 200
      },
      {
        title: '复制文案',
        dataIndex: 'copyCopywriting',
        slots: { customRender: 'copyCopywriting' },
        key: 'copyCopywriting',
        resizable: true,
        align: 'center',
        width: 200
      },
      {
        title: '倒计时开关',
        dataIndex: 'countdownSwitch',
        slots: { customRender: 'countdownSwitch' },
        key: 'countdownSwitch',
        resizable: true,
        align: 'center',
        width: 200
      },
      {
        title: '倒计时秒数',
        dataIndex: 'countdownSecond',
        slots: { customRender: 'countdownSecond' },
        key: 'countdownSecond',
        resizable: true,
        align: 'center',
        width: 200
      },
      {
        title: '操作',
        slots: { customRender: 'deal' },
        key: 'deal',
        fixed: 'right',
        width: 200
      }
    ])
    return {
      ...toRefs(dics),
      handleResizeColumn: (w, col) => {
        col.width = w
      },
      columns,
      ...toRefs(inject('initState'))
    }
  }
}
</script>
